module.exports = __webpack_public_path__ + "static/media/vf_mtshirts_core.bddb6085.svg";